/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const socialProfileSuggestionContactResponseDtoSchema = z.object({
    "id": z.uuid(),
"fullName": z.nullable(z.string()),
"firstName": z.nullable(z.string()),
"lastName": z.nullable(z.string()),
"preferredName": z.nullable(z.string()),
"company": z.nullable(z.string()),
"title": z.nullable(z.string())
    })